import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';

import { Tooltip as NBTooltip, } from "native-base";

const POSITION = {
    BOTTOM: 'bottom',
    HORIZONTAL: 'horizontal',
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top',
    VERTICAL: 'vertical',
};

const defaults = {
    className: '',
    delay: 0,
    hideOnClick: true,
    passthrough: true,
    showOnClick: false,
    position: POSITION.TOP,
    toolTipHover: true,
    theme: {},
};


const ComponentWithoutOnFocus = forwardRef(({children, onFocus: _, childProps, ...props}, ref) => {
  return React.Children.map(children, (child) => React.cloneElement(child, {...props, ...childProps, ref}))
});

const tooltipFactory = (options) => {
    const {
        className: defaultClassName,
        delay: defaultDelay,
        hideOnClick: defaultHideOnClick,
        showOnClick: defaultShowOnClick,
        passthrough: defaultPassthrough,
        position: defaultPosition,
        theme: defaultTheme,
    } = { ...defaults, ...options };

    return (ComposedComponent) => {
        class TooltippedComponent extends Component {
            static propTypes = {
                children: PropTypes.node,
                className: PropTypes.string,
                onClick: PropTypes.func,
                onMouseEnter: PropTypes.func,
                onMouseLeave: PropTypes.func,
                theme: PropTypes.shape({
                    tooltip: PropTypes.string,
                    tooltipActive: PropTypes.string,
                    tooltipWrapper: PropTypes.string,
                }),
                tooltip: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.node,
                ]),
                toolTipHover: PropTypes.bool,
                openOnFocus: PropTypes.bool,
                tooltipDelay: PropTypes.number,
                tooltipHideOnClick: PropTypes.bool,
                tooltipPosition: PropTypes.oneOf(Object.keys(POSITION).map(key => POSITION[key])),
                tooltipShowOnClick: PropTypes.bool,
                onActivate: PropTypes.func,
                oDeactivate: PropTypes.func,
            };

            static defaultProps = {
                openOnFocus: true,
                className: defaultClassName,
                tooltipDelay: defaultDelay,
                tooltipHideOnClick: defaultHideOnClick,
                tooltipPosition: defaultPosition,
                tooltipShowOnClick: defaultShowOnClick,
            };

            state = {
                active: false,
                position: this.props.tooltipPosition,
                visible: false,
            };

            constructor(props) {
                super(props);
                this.tooltipId = btoa(''+Math.random())
            }

            componentDidMount = () => {
                // if(this.props.toolTipHover) {
                //     document.addEventListener('mousemove', this.handleMouseMove);
                // }
            };

            // componentWillUnmount() {
            //     if (this.tooltipNode) {
            //         events.removeEventListenerOnTransitionEnded(this.tooltipNode, this.onTransformEnd);
            //     }
            //     if (this.timeout) clearTimeout(this.timeout);

            //     if(this.props.toolTipHover) {
            //         document.removeEventListener('mousemove', this.handleMouseMove)
            //     }
            // }

            // onTransformEnd = (e) => {
            //     if (e.propertyName === 'transform') {
            //         events.removeEventListenerOnTransitionEnded(this.tooltipNode, this.onTransformEnd);
            //         this.setState({ visible: false });
            //     }
            // };

            getPosition(element) {
                const { tooltipPosition, position } = this.props;
                if (position) { return position; }
                if (tooltipPosition === POSITION.HORIZONTAL) {
                    const origin = element.getBoundingClientRect();
                    const { width: ww } = getViewport();
                    const toRight = origin.left < ((ww / 2) - (origin.width / 2));
                    return toRight ? POSITION.RIGHT : POSITION.LEFT;
                } else if (tooltipPosition === POSITION.VERTICAL) {
                    const origin = element.getBoundingClientRect();
                    const { height: wh } = getViewport();
                    const toBottom = origin.top < ((wh / 2) - (origin.height / 2));
                    return toBottom ? POSITION.BOTTOM : POSITION.TOP;
                }
                return tooltipPosition;
            }

            // activate({ top, left, position , timeout = this.props.tooltipDelay }) {
            //     if (this.deactivateTimeout) clearTimeout(this.deactivateTimeout);

            //     if (this.state.active) {
            //         return;
            //     }

            //     if (this.timeout) clearTimeout(this.timeout);
            //     this.setState({ visible: true, position });
            //     this.timeout = setTimeout(() => {
            //         this.setState({ active: true, top, left });
            //         this.props.onActivate && this.props.onActivate();
            //     }, timeout);
            // }

            // activateImmidiatly(props) {
            //     this.activate({...props, timeout: 0});
            // }

            // deactivate(timeout = this.props.tooltipDelay) {
            //     if (this.timeout) clearTimeout(this.timeout);

            //     if (this.state.active) {
            //         if (this.deactivateTimeout) clearTimeout(this.deactivateTimeout);

            //         this.deactivateTimeout = setTimeout(() => {
            //             events.addEventListenerOnTransitionEnded(this.tooltipNode, this.onTransformEnd);
            //             this.setState({ active: false });
            //             this.props.onDeactivate && this.props.onDeactivate();
            //         }, timeout);
            //     } else if (this.state.visible) {
            //         this.setState({ visible: false });
            //     }
            // }

            // deactivateImmidiatly() {
            //     this.deactivate(0);
            // }

            calculatePosition(element) {
                const position = this.getPosition(element);
                const { top, left, height, width } = element.getBoundingClientRect();
                const xOffset = window.scrollX || window.pageXOffset;
                const yOffset = window.scrollY || window.pageYOffset;
                if (position === POSITION.BOTTOM) {
                    return {
                        top: top + height + yOffset,
                        left: left + (width / 2) + xOffset,
                        position,
                    };
                } else if (position === POSITION.TOP) {
                    return {
                        top: top + yOffset,
                        left: left + (width / 2) + xOffset,
                        position,
                    };
                } else if (position === POSITION.LEFT) {
                    return {
                        top: top + (height / 2) + yOffset,
                        left: left + xOffset,
                        position,
                    };
                } else if (position === POSITION.RIGHT) {
                    return {
                        top: top + (height / 2) + yOffset,
                        left: left + width + xOffset,
                        position,
                    };
                }
                return {
                    position
                };
            }


            // handleMouseMove = (e) => {
            //     let element = document.elementFromPoint(e.pageX - window.pageXOffset, e.pageY - window.pageYOffset);


            //     if(!element) { return this.deactivate(); }
            //     let parentTooltipElement = element.closest(`[data-react-toolbox-tooltip="${this.tooltipId}"]`);
            //     let openerQuery = `[data-react-toolbox-tooltip-opener="${this.tooltipId}"]`;
            //     let isOpener = element.matches(openerQuery) ||
            //         (element.parentElement && element.parentElement.matches(openerQuery));

            //     if(!isOpener && !parentTooltipElement) {
            //         this.deactivate();
            //         return;
            //     }

            //     if (this.deactivateTimeout) clearTimeout(this.deactivateTimeout);

            //     if(isOpener) {
            //         this.activate(this.calculatePosition(element));
            //     }

                // let element = document.elementFromPoint(e.pageX, e.pageY);
                //
                // if(!element) { return this.deactivate(); }
                // let parentTooltipElement = element.closest(`[data-react-toolbox-tooltip="${this.tooltipId}"]`);
                //
                // if(!parentTooltipElement) {
                //     this.deactivate();
                //     return;
                // }
                //
                // if (this.deactivateTimeout) clearTimeout(this.deactivateTimeout);
                //
                // let parentOpener = element.closest(`[data-react-toolbox-tooltip-opener]`);
                //
                // if(parentOpener) {
                //     this.activate(this.calculatePosition(parentOpener));
                // }
            // };

            handleClick = (event) => {
                // if (this.props.tooltipHideOnClick && this.state.active) {
                //     this.deactivateImmidiatly();
                // }

                // if (this.props.tooltipShowOnClick && !this.state.active) {
                //     this.activateImmidiatly(this.calculatePosition(event.currentTarget));
                // }

                if (this.props.onClick) this.props.onClick(event);
            };

            render() {
                const { position } = this.props;
                // const { active, left, top, visible } = this.state;
                // const positionClass = `tooltip${position.charAt(0).toUpperCase() + position.slice(1)}`;
                const {
                    children,
                    className,
                    toolTipHover,
                    openOnFocus,
                    // theme,
                    disabled,
                    onClick,            // eslint-disable-line no-unused-vars
                    onMouseEnter,       // eslint-disable-line no-unused-vars
                    onMouseLeave,       // eslint-disable-line no-unused-vars
                    tooltip,
                    tooltipDelay,       // eslint-disable-line no-unused-vars
                    tooltipHideOnClick, // eslint-disable-line no-unused-vars
                    tooltipPosition,    // eslint-disable-line no-unused-vars
                    tooltipShowOnClick, // eslint-disable-line no-unused-vars

                    childProps: __childProps,

                    tooltipProps,
                    ...other
                } = this.props;

                // const _className = classnames(theme.tooltip, {
                //     [theme.tooltipActive]: active,
                //     [theme[positionClass]]: theme[positionClass],
                // });

                const childProps = {
                    ...other,
                    className,
                    'data-react-toolbox-tooltip-opener': this.tooltipId,
                    onClick: this.handleClick,
                };

                const shouldPass = typeof ComposedComponent !== 'string' && defaultPassthrough;
                const finalProps = shouldPass ? { ...childProps } : childProps;

                if (!tooltip) {
                    return null;
                }

                if (!children) {
                    return null;
                }

                const tooltipChildren = !openOnFocus ? <ComponentWithoutOnFocus childProps={__childProps}>{children}</ComponentWithoutOnFocus> : children;


                let tooltipNode = <NBTooltip
                    {...tooltipProps}
                    hasArrow
                    isDisabled={disabled}
                    label={tooltip}
                    placement={position}
                    >{ tooltipChildren }</NBTooltip>;


                if (!ComposedComponent) {
                    return tooltipNode
                }

                return React.createElement(ComposedComponent, finalProps, tooltipNode);
            }
        }

        return TooltippedComponent;
    };
};

export const Tooltip = tooltipFactory({})();

const themedTooltipFactory = options => tooltipFactory(options);
export { themedTooltipFactory as tooltipFactory };
